// Deprecated: users routing is defined in route.tsx. Export an empty route config to avoid duplication.
import type { FuseRouteItemType } from '@fuse/utils/FuseUtils';
const routes: FuseRouteItemType[] = [];
export default routes;
